import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"
import { extraServiceMemory } from "../../Objects/Memory/Memory"
import { ExtraServiceEntity } from "../../Objects/ExtraService/ExtraServiceEntity"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"

export const useGetExtraService = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetExtraService = async (onSuccess: any, database: string = API_ROUTES.EXTRA_SERVICE.GET_ALL) => {
    enableLoad()

    try {
      const response = await GetRequest<ExtraServiceEntity[]>(database)

      if (response.success) {
        const temp = response.data?.map((ss) => new ExtraServiceEntity(ss)) ?? []

        extraServiceMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetExtraService,
  }
}
